import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from 'react-bootstrap/Modal';
import ModalHeader from '../../../components/ModalHeader';
import { Container, Row, Col } from 'react-bootstrap';
import Button from '../../../components/Button';

export type ReferenceMaterialsType = {
  title?: string;
  subTitles: { subTitle: string; link: string; target: string }[];
}[];

const ReferenceMaterialsOptions: ReferenceMaterialsType = [
  {
    subTitles: [
      {
        subTitle: 'Accident Insurance Brochure',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: 'Dependent Verification Document List',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: 'Domestic Partner Fact Sheet',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: 'Hospital Indemnity Insurance Brochure',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: 'Legal Services Brochure',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: 'Medicare Information',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: 'Working Post Age 65 Resource',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: 'Critical Illness Insurance Brochure',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: 'Dependent Eligibility Verification Process',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: 'Domestic Partner Tax Consequences',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: 'Identity Protection Brochure',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: 'Maximizing Your Dental Benefits',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: 'Teledoc Benefits Guide',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
    ],
  },
];

export type ReferenceMaterialsProps = {
  showReferenceMaterialsModal: boolean;
  handleCloseReferenceMaterialsModal: () => void;
};

function ReferenceMaterialsModal({
  showReferenceMaterialsModal,
  handleCloseReferenceMaterialsModal,
}: ReferenceMaterialsProps) {
  return (
    <>
      <Modal
        className={'p-0'}
        show={showReferenceMaterialsModal}
        onHide={handleCloseReferenceMaterialsModal}
        dialogClassName="modal-xl"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <ModalHeader closeButton={true} leftIcon={light('folder')}>
          <h4 className="text-sm-20-lg-24">Reference Materials</h4>
        </ModalHeader>
        <Modal.Body>
          <Container className={'p-0'}>
            {ReferenceMaterialsOptions.map(({ title, subTitles }, index) => {
              return (
                <Row key={index}>
                  <Col>
                    <h6
                      className={
                        'mb-0 pb-4 border-bottom border-info text-primary text-fs-base fw-normal'
                      }
                    >
                      {title}
                    </h6>
                  </Col>
                  <Col className={'col-12 mc-layout-2-col mb-12'}>
                    {subTitles.map(({ subTitle, link, target }, index) => {
                      return (
                        <Row key={index}>
                          <Col>
                            <div
                              className={
                                'd-flex mb-0 py-6 text-fs-6 border-bottom border-info fw-light'
                              }
                              key={index}
                            >
                              {subTitle}
                              <a
                                className={'text-decoration-none ms-auto'}
                                href={link}
                                target={target}
                              >
                                <FontAwesomeIcon icon={light('file-pdf')} />
                                <span className={'ms-5'}>PDF</span>
                              </a>
                            </div>
                          </Col>
                        </Row>
                      );
                    })}
                  </Col>
                </Row>
              );
            })}
          </Container>
        </Modal.Body>
        <Modal.Footer className={'pt-0'}>
          <Button
            variant="primary-outline"
            onMouseDown={handleCloseReferenceMaterialsModal}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ReferenceMaterialsModal;
